import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqDatepickerComponent } from './components/datiq-datepicker/datiq-datepicker.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import {
    DatiqValidatorsRegisterService,
    DatiqInputErrorTypes,
} from '@dat/datiq-components-pkg/utils';
import {
    DatiqDatepickerValidatorDatemaxService,
    DatiqDatepickerValidatorDateminService,
    DatiqDatepickerValidatorDaterangeService,
} from './components/datiq-datepicker/services';
import { DatiqDatepickerValidatorDateMinDaysService } from './components/datiq-datepicker/services/datiq-datepicker-validator-date-min-days.service';
import { DatiqDatepickerValidatorDateMaxDaysService } from './components/datiq-datepicker/services/datiq-datepicker-validator-date-max-days.service';

const components = [DatiqDatepickerComponent];

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        DatiqIconsModule,
        ReactiveFormsModule,
        MatNativeDateModule,
    ],
    exports: [...components],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'fill' },
        },
    ],
})
export class DatiqDatepickerModule {
    constructor(
        private _validatorRegistry: DatiqValidatorsRegisterService,
        private _datemax: DatiqDatepickerValidatorDatemaxService,
        private _datemin: DatiqDatepickerValidatorDateminService,
        private _daterange: DatiqDatepickerValidatorDaterangeService,
        private _daysMin: DatiqDatepickerValidatorDateMinDaysService,
        private _daysMax: DatiqDatepickerValidatorDateMaxDaysService
    ) {
        this._validatorRegistry.register(
            DatiqInputErrorTypes.DateMax,
            this._datemax
        );
        this._validatorRegistry.register(
            DatiqInputErrorTypes.DateMin,
            this._datemin
        );
        this._validatorRegistry.register(
            DatiqInputErrorTypes.DateRange,
            this._daterange
        );
        this._validatorRegistry.register(
            DatiqInputErrorTypes.DateMinDays,
            this._daysMin
        );
        this._validatorRegistry.register(
            DatiqInputErrorTypes.DateMaxDays,
            this._daysMax
        );
    }
}
